__webpack_require__.p = "/Realtime_weather_app/";